// extracted by mini-css-extract-plugin
module.exports = {"summary":"Meals_summary__3wms8"};